import { createSlice, PayloadAction } from '@reduxjs/toolkit';

import {
    GET_USERS_SUCCESS,
    DELETE_USER,
    DELETE_MANY_USERS,
    DEACTIVATE_USER,
    SAVE_USER,
    UPDATE_USER,
    ACTIVATE_USER,
    GET_USER_DETAIL_SUCCESS,
    GET_USER_DETAIL,
    GET_USER_DETAIL_FAIL,
} from '../../constants/actions/users.constants';
import { LOGOUT } from '../../constants/actions/auth.constants';
import type { IUser } from '../../types';

const NAME = 'surveyUsers';

interface DetailState {
    data: IUser | null;
    loading: boolean;
}

interface SurveyUsersState {
    list: IUser[];
    detail: DetailState;
}

const initialDetail: DetailState = {
    data: null,
    loading: false,
};

const initialState: SurveyUsersState = {
    list: [],
    detail: initialDetail,
};

const SurveyUsersSlice = createSlice({
    name: NAME,
    initialState,
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(GET_USERS_SUCCESS, (state, action) => {
                state.list = (action as PayloadAction<IUser[]>).payload;
            })
            .addCase(DELETE_USER, (state, action) => {
                const payload = (action as PayloadAction<number>).payload;
                const index = state.list.findIndex(
                    (user) => payload === user.userId,
                );
                if (index >= 0) {
                    state.list.splice(index, 1);
                }
            })
            .addCase(DELETE_MANY_USERS, (state, action) => {
                const payload = (action as PayloadAction<number[]>).payload;
                state.list = state.list.filter(
                    (user) => !payload.includes(user.userId),
                );
            })
            .addCase(DEACTIVATE_USER, (state, action) => {
                const payload = (action as PayloadAction<number>).payload;
                const index = state.list.findIndex(
                    (user) => payload === user.userId,
                );
                if (index >= 0) {
                    state.list[index].isActive = false;
                }
            })
            .addCase(ACTIVATE_USER, (state, action) => {
                const payload = (action as PayloadAction<number>).payload;
                const index = state.list.findIndex(
                    (user) => payload === user.userId,
                );
                if (index >= 0) {
                    state.list[index].isActive = true;
                }
            })
            .addCase(SAVE_USER, (state, action) => {
                state.list.push((action as PayloadAction<IUser>).payload);
            })
            .addCase(UPDATE_USER, (state, action) => {
                const { id, user } = (
                    action as PayloadAction<{ id: number; user: IUser }>
                ).payload;
                const index = state.list.findIndex((u) => id === u.userId);
                if (index >= 0) {
                    state.list[index] = user;
                }
            })
            .addCase(GET_USER_DETAIL_SUCCESS, (state, action) => {
                state.detail.data = (action as PayloadAction<IUser>).payload;
                state.detail.loading = false;
            })
            .addCase(GET_USER_DETAIL, (state) => {
                state.detail.loading = true;
            })
            .addCase(GET_USER_DETAIL_FAIL, (state) => {
                state.detail.loading = false;
            })
            .addCase(LOGOUT, (state) => {
                state.list = [];
                state.detail = initialDetail;
            });
    },
});

export type { SurveyUsersState };
export default SurveyUsersSlice;
